import { ScrollReveal, FloatingImage } from '@/components/Animations';

const RABAIS_IMG = 'https://static.wixstatic.com/media/bf3085_ddbb18bcd00f4f63b2d2b4ac8632c508~mv2.jpg/v1/fill/w_300,h_520,al_c,q_80/bf3085_ddbb18bcd00f4f63b2d2b4ac8632c508~mv2.jpg';
const EVENT_IMG_1 = 'https://static.wixstatic.com/media/90a441_60439826d39e498088a231ef1b86f093~mv2.jpg/v1/fill/w_500,h_376,al_c,q_80/90a441_60439826d39e498088a231ef1b86f093~mv2.jpg';
const EVENT_IMG_2 = 'https://static.wixstatic.com/media/bf3085_8cde01d9170d4080b69c270fd0326b65~mv2.jpg/v1/fill/w_300,h_400,al_c,q_80/bf3085_8cde01d9170d4080b69c270fd0326b65~mv2.jpg';
const EVENT_IMG_3 = 'https://static.wixstatic.com/media/bf3085_216ef68106c84c059180d3f5bb8ca989~mv2.jpg/v1/fill/w_500,h_645,al_c,q_80/bf3085_216ef68106c84c059180d3f5bb8ca989~mv2.jpg';
const EVENT_IMG_4 = 'https://static.wixstatic.com/media/bf3085_2940fb191354404eb9b294d079f4b05b~mv2.jpg/v1/fill/w_300,h_307,al_c,q_80/bf3085_2940fb191354404eb9b294d079f4b05b~mv2.jpg';
const EVENT_IMG_5 = 'https://static.wixstatic.com/media/bf3085_04fcf055f4aa4ad0988e8e9794fed1e3~mv2.jpg/v1/fill/w_499,h_419,al_c,q_80/bf3085_04fcf055f4aa4ad0988e8e9794fed1e3~mv2.jpg';
const PROMO_IMG_1 = 'https://static.wixstatic.com/media/90a441_5adac3e046264b8e8595b32c4f5baa66~mv2.jpg/v1/fill/w_500,h_212,al_c,q_80/90a441_5adac3e046264b8e8595b32c4f5baa66~mv2.jpg';
const PROMO_IMG_2 = 'https://static.wixstatic.com/media/90a441_be0c397bf48044b6b16dd2762b9d5bbf~mv2.jpg/v1/fill/w_500,h_163,al_c,q_80/90a441_be0c397bf48044b6b16dd2762b9d5bbf~mv2.jpg';

export default function Promotions() {
  return (
    <div data-testid="promotions-page">
      {/* Hero */}
      <section className="py-20 sm:py-28 px-4">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <p className="text-xs uppercase tracking-[0.3em] mb-4 font-semibold" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--color-primary)' }}>
              Restez à l'affût
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              PROMOTIONS ET ÉVÉNEMENTS
            </h1>
          </ScrollReveal>
        </div>
      </section>

      {/* Événements à venir */}
      <section className="pb-16 px-4">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl sm:text-3xl font-light mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>
              ÉVÉNEMENTS À VENIR ...
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <div className="p-8 rounded-2xl mb-12" style={{ backgroundColor: 'var(--color-muted)', border: '1px solid var(--color-border)' }}>
              <h3 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                Surveillez nos publications sur Facebook pour connaître nos différentes promotions au comptoir lunch !
              </h3>
              <p className="text-lg">
                Plusieurs types de rabais vous sont offerts dans notre section des surgelés.
              </p>
            </div>
          </ScrollReveal>

          {/* Rabais + Fidélité */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <ScrollReveal>
              <FloatingImage
                src={RABAIS_IMG}
                alt="Rabais surgelés"
                className="w-full max-w-xs mx-auto rounded-2xl overflow-hidden shadow-xl"
                duration={6}
              />
            </ScrollReveal>

            <ScrollReveal delay={0.15}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 items-start">
                <FloatingImage
                  src={EVENT_IMG_1}
                  alt="Programme fidélité"
                  className="w-full rounded-2xl overflow-hidden shadow-xl"
                  duration={7}
                />
                <div className="space-y-4">
                  <h3 className="text-xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                    Connaissez-vous le programme de fidélité ?
                  </h3>
                  <div className="space-y-2 text-base">
                    <p>1- Demandez votre carte de fidélité lors de votre visite.</p>
                    <p>2- Pour tout achat, cela vous donne une étampe.</p>
                    <p>3- Une fois votre carte complétée, vous obtenez une gratuité.</p>
                    <p className="ml-4">Au choix : un repas ou un assortiment de 6 desserts.</p>
                  </div>
                  <p className="text-base">
                    Miam ! Applicable sur tous les services. Sur commande ou directement au comptoir lunch.
                  </p>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Événements antérieurs */}
      <section className="py-16 px-4" style={{ backgroundColor: 'var(--color-muted)' }}>
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl sm:text-3xl font-light mb-12" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>
              ÉVÉNEMENTS/PROMOTIONS/COLLABORATIONS ANTÉRIEURS...
            </h2>
            <p className="text-lg font-semibold mb-8" style={{ color: 'var(--color-secondary)' }}>ÉTÉ 2024</p>
          </ScrollReveal>

          <div className="space-y-12">
            <ScrollReveal delay={0.1}>
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 p-8 rounded-2xl" style={{ backgroundColor: 'var(--color-card)', border: '1px solid var(--color-border)' }}>
                <div className="lg:col-span-3">
                  <img src={EVENT_IMG_2} alt="Repas en salle" className="w-full rounded-xl" />
                </div>
                <div className="lg:col-span-9 space-y-4">
                  <h3 className="text-2xl font-light" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Repas en salle à manger</h3>
                  <h3 className="text-2xl font-light" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>La Virée Enracinée</h3>
                  <p className="text-base leading-relaxed">
                    Concept Gourmet Traiteur est fier de participer à la 4e édition de La Virée Enracinée de Portneuf, Culture de Saveurs. Notre salade gourmande de l'Ouest est disponible à notre comptoir lunch, du lundi au vendredi, de 9h à 16h, et ce, jusqu'au 1er septembre. Un vrai délice pour les papilles !
                  </p>
                  <p className="text-base leading-relaxed">
                    Nous serons à Saint-Thuribe pour les festivités du musée ambulant dans les semaines du 18 juillet au 18 août 2024 ! Nous vous donnons rendez-vous pour les déjeuners du dimanche matin, les dîners du vendredi midi et les soupers du samedi soir. C'est un événement à ne pas manquer !
                  </p>
                  <p className="text-sm font-medium" style={{ color: 'var(--color-muted-fg)' }}>375 A, rue Principale, Saint-Thuribe</p>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.15}>
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 p-8 rounded-2xl" style={{ backgroundColor: 'var(--color-card)', border: '1px solid var(--color-border)' }}>
                <div className="lg:col-span-4">
                  <img src={EVENT_IMG_3} alt="Repas spécial été" className="w-full rounded-xl" />
                </div>
                <div className="lg:col-span-8 space-y-4">
                  <h3 className="text-2xl font-light" style={{ fontFamily: 'Cormorant Garamond, serif' }}>La route des Arts et Saveurs Portneuf</h3>
                  <p className="text-base leading-relaxed">
                    Concept Gourmet Traiteur est fier de participer aux «arrêts découverte» en tant qu'offre alimentaire le 21 et 22 septembre 2024 lors du circuit Arts et Saveurs de Portneuf. Nous vous donnons rendez-vous chez Miel & CO.
                  </p>
                  <p className="text-sm font-medium" style={{ color: 'var(--color-muted-fg)' }}>457, rang du Coteau-des-Roches, Portneuf</p>
                </div>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <ScrollReveal delay={0.2}>
                <img src={EVENT_IMG_4} alt="Arts et Saveurs" className="w-full rounded-2xl shadow-lg" />
              </ScrollReveal>
              <ScrollReveal delay={0.25}>
                <img src={EVENT_IMG_5} alt="Motocross Deschambault" className="w-full rounded-2xl shadow-lg" />
              </ScrollReveal>
            </div>
          </div>
        </div>
      </section>

      {/* Saine alimentation */}
      <section className="py-16 sm:py-24 px-4">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl sm:text-3xl font-semibold mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              PROMOTION SAINE ALIMENTATION
            </h2>
            <p className="text-lg font-semibold mb-6">
              Concept Gourmet vous propose un programme sous forme de séance individuelle afin de vous familiariser avec la saine alimentation !
            </p>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <ScrollReveal delay={0.1}>
              <div className="space-y-3 text-lg">
                <p>VOUS AIMERIEZ EN SAVOIR DAVANTAGE SUR CE SUJET ?</p>
                <p>VOUS AIMERIEZ MANGER MIEUX ?</p>
                <p>VOUS NE SAVEZ PLUS QUOI MANGER ?</p>
                <p>VOUS AIMERIEZ SAVOIR QUOI ACHETER ET COMMENT L'APPRÊTER ?</p>
                <p>VOUS AVEZ UN SOUCI ALIMENTAIRE ET AIMERIEZ ADAPTER VOS REPAS ?</p>
                <p className="pt-4 text-base leading-relaxed">
                  Caroline, la propriétaire, se fera un plaisir de vous guider. Elle a une formation en nutrition qui vous aidera à ne pas voir tout comme une montagne et vous donnera des outils pour que vous puissiez les appliquer à la maison.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <div className="space-y-6">
                <img src={PROMO_IMG_1} alt="Saine alimentation" className="w-full rounded-2xl shadow-lg" />
                <img src={PROMO_IMG_2} alt="Promotion" className="w-full rounded-2xl shadow-lg" />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Soirée découverte */}
      <section className="py-16 px-4" style={{ backgroundColor: 'var(--color-muted)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <h2 className="text-2xl sm:text-3xl font-semibold mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              SOIRÉE DÉCOUVERTE
            </h2>
            <p className="text-base leading-relaxed mb-4">
              Avec la collaboration de la Ville de Saint-Marc, des conférences avaient lieu sous le thème : Plusieurs belles régions à travers le monde !
            </p>
            <p className="text-base leading-relaxed mb-8">
              Je suis sur place afin de vous mettre dans l'ambiance en vous présentant plusieurs bouchées aux saveurs du pays présenté.
            </p>
            <p className="text-xl font-semibold" style={{ color: 'var(--color-primary)' }}>
              PROMOTION EN VIGUEUR...
            </p>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}
